import { useRef } from 'react';
import CCFooter from '../../components/CreatorCash/CCFooter/CCFooter';
import CCHeader from '../../components/CreatorCash/CCHeader/CCHeader';
import CreatorCashSub from '../../components/CreatorCash/CreatorCashSub/CreatorCashSub';
import Creators from '../../components/CreatorCash/Creators/Creators';
import Welcome from '../../components/CreatorCash/Welcome/Welcome';
import './CreatorCash.css';
import { useCreatorCashContext } from '../../context/CreatorCashProvider';
import FAQ from '../../components/CreatorCash/FAQ/FAQ';
import CompareYourOptions from '../../components/CreatorCash/CompareYourOptions/CompareYourOptions';
import HowItWorks from '../../components/CreatorCash/HowItWorks/HowItWorks';

export default function CreatorCash() {

    const { state } = useCreatorCashContext();
    const scrollRef = useRef(null);

    const scrollToRef = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollIntoView({
                behavior: "smooth",  // smooth scroll
                block: "start",      // align to top
            });
        }
    };

    return (
        <div className='creator-cash-container'>
            <CCHeader />
            <Welcome scrollToRef={scrollToRef} />
            {state?.creatorsSection && <Creators scrollToRef={scrollToRef} />}
            {state?.compareYourOptions && <CompareYourOptions scrollToRef={scrollToRef} />}
            {state?.howItWorks && <HowItWorks />}
            <CreatorCashSub scrollRef={scrollRef} scrollToRef={scrollToRef} />
            {state?.faq && <FAQ />}
            <CCFooter />
        </div>
    )
}
